import _ from "lodash";
import { store } from "../../redux/store";
import { deleteCheckList, updateCheckList } from "../../redux/dispatchers";
import { post } from "../api/common";

export const fetchManagement = async (type) => {
  try {
    let texts = [];
    const caseId = store.getState().gameStates.case.id;
    const contents = store.getState().gameStates[type];

    // remove empty items
    _.forEach(contents, (content) => {
      if (!content.item) deleteCheckList(type, content.id);
    });

    // retrieve only answer string from each object
    _.forEach(contents, (content) => {
      texts.push(content.item);
    });

    // look up the diagnosis by texts array, if wrong answer, id of the item will be empty
    const evaluations = (
      await post("client/managements", {
        texts,
        caseId,
        type,
      })
    ).data;

    // update the local states
    for (let i = 0; i < evaluations.length; i++) {
      // set evaluation to null if id does not exist
      if (evaluations[i].id === "") evaluations[i] = null;
      // break if index out of bound
      if (contents.length <= i) break;
      // update check list if result exists (by index)
      updateCheckList(
        type,
        contents[i].id,
        contents[i].type,
        contents[i].item,
        evaluations[i]
      );
    }
  } catch (e) {
    console.log(e);
  }
};
